import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/explore/components/ExploreNavigation/ExploreNavigation.tsx");
